import appendChildError from './appendChildError';

export const loadScript = (url: string) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;

        script.onload = () => resolve(true);
        script.onerror = error => {
            console.error(error);
            reject(error);
        };
        try {
            document.body.appendChild(script);
        } catch (e: any) {
            console.error(appendChildError(e, document.body.appendChild, script));
        }
    });
};
